import { useNavigate } from "react-router-dom";
import React, { Component } from 'react';
import { useState, useEffect } from 'react';
import { setTokenHeader, getJwtFromCookies, basePort, getUsernameJwt, headers, isExpiredJwt, queryParameters, renderRedirect } from "../../module_auth/AuthService"
import { PaginationCustom } from "../../component/common/PaginationCustom"
import { JobCardMypage } from "./JobCardMypage"
import { isValidSearchPage } from '../common/BaseUtil';

export function JobListMypage() {
    const [objectList, setObjectList] = useState([]);

    ////pagination
    const [pageList, setPageList] = useState([]);
    const [lastPage, setLastPage] = useState();
    const [activePageIndex, setActivePageIndex] = useState();
    const [redirect, setRedirect] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState("");
    const [accessToken, setAccessToken] = useState("");
    const [mbrId, setMbrId] = useState("");

    const navigate = useNavigate();

    //const queryParameters = new URLSearchParams(window.location.search)
    const page = queryParameters.get("page")
    const next = queryParameters.get("next")
    const previous = queryParameters.get("previous")
    ////pagination

    useEffect(() => {
        if(getJwtFromCookies() == null || isExpiredJwt(getJwtFromCookies())){
            //alert
            setRedirect(true)
        } else {
            setRedirect(false)
            setAccessToken(getJwtFromCookies())
            setMbrId(getUsernameJwt(getJwtFromCookies()))

            //currentPage
            let currentPage
            if(!isValidSearchPage(page)){
                let localStoragePage = localStorage.getItem("page")
                currentPage = !isValidSearchPage(localStoragePage) ? "1" : localStorage.getItem("page")
            } else {
                currentPage = page == "0" ? "1" : page
            }
            //end currentPage
            
            navigate("/job_list_mypage?page="  + currentPage);
            localStorage.setItem("page", currentPage)

            let url = basePort + '/get/jobs/mypage/' + currentPage
            let activePageIndex = (currentPage-1)%2
            if(next != null){
                url = basePort + '/get/jobs/mypage/next/' + currentPage
                activePageIndex = (currentPage-1)%2
            } else if(previous != null) {
                url = basePort + '/get/jobs/mypage/previous/' + currentPage
                activePageIndex = (currentPage-1)%2
            }
            
            setTokenHeader(getJwtFromCookies())
            fetch(url, 
            {method:'GET', headers,
                body:JSON.stringify()})
                .then(response => response.json())
                .then(response => {
                setObjectList(response.cardList)
                
                ////pagination
                setPageList(response.displayPages)
                setLastPage(response.lastPage)
                setActivePageIndex(activePageIndex)
                console.log("activePageIndex: " + activePageIndex)
                ////pagination
                
            }).catch(error => console.log(error))
            
        }
        
    }, []);

    function clickRegister() {
        let url = "/job_reg_select"
        navigate(url);
    }

    return (
        <div>
            {renderRedirect(redirect, '/login')}
            <main class="page lanidng-page">
                <section>
                    <div class="container" style={{paddingTop:'100px', marginTop: '10px', marginBottom: '10px'}}>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><span>마이페이지</span></li>
                            <li class="breadcrumb-item"><span>등록정보</span></li>
                        </ol>
                        <div class="row" style={{display: 'flex'}}>
                            <div class="col-md-6 d-md-flex justify-content-xxl-center">
                                <p class="d-flex justify-content-center justify-content-md-center align-items-xxl-center" style={{fontFamily: 'Nanum Gothic',fontWeight: 'bold', fontSize: '24px', marginTop: '15px'}}>채용정보</p>
                            </div>
                            <div class="col-md-6 d-flex d-md-flex justify-content-center justify-content-md-center align-items-md-center"><button class="btn btn-primary btn-sm text-end" type="button" onClick={clickRegister} style={{borderRadius: '5px'}}>등록</button></div>
                        </div>
                    {/* end of container */}
                    </div>

                    <div class="container">
                        {objectList.map((object, index) => (
                            <JobCardMypage object={object} index={index} key={index} returnTo={"/job_list_mypage"}/>
                        ))}
                    </div> 
                        <PaginationCustom 
                            lastPage={lastPage}
                            page={page}
                            pageList={pageList}
                            activePageIndex={activePageIndex}
                            url={'job_list_mypage'}
                        />
                </section>
            </main>
        </div>
    );
}